/**
 * Marks requests made while a mAX tool is running.
 *
 * mAX write tools execute in the browser and call the ordinary endpoints as the signed-in
 * user, so without a marker the API records an agent edit in the audit trail exactly like
 * a manual one. The window is kept as narrow as possible - one tool call - and only writes
 * are recorded, so a read that happens to overlap costs nothing.
 */

let depth = 0

export function beginAgentWrites() {
    depth += 1
}

export function endAgentWrites() {
    depth = Math.max(0, depth - 1)
}

export function getAgentHeaders() {
    return depth > 0 ? { "x-mx-agent": "max" } : {}
}

/** Runs fn with every request it makes marked as mAX's. */
export async function withAgentWrites(fn) {
    beginAgentWrites()

    try {
        return await fn()
    } finally {
        endAgentWrites()
    }
}
